export default __webpack_public_path__ + "static/media/bike1.f0c5bc70.png";